import React from 'react';
import {Container} from 'react-bootstrap';
import Base from "../layout/Base";

const NotFound = () => {
    return (
        <Base>
            <Container className="d-flex justify-content-center align-items-center vh-100">
                <div className="text-center bs-font-sans-serif">
                    <h1>404 Not Found</h1>
                </div>
            </Container>
        </Base>
    );
};

export default NotFound;